export default {
  setWorkspaceUsers(state, payload) {
    state.workspaceUsers = payload;
  },
  setWorkspaceUserGroups(state, payload) {
    state.workspaceUserGroups = payload;
  },
};
